import type { RouteRecordRaw } from 'vue-router'
import DefaultLayout from '@/layouts/DefaultLayout.vue'
import Dashboard from '@/views/dashboard/index.vue'

const dashboardRoutes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'Dashboard',
    component: Dashboard,
    meta: {
      layout: DefaultLayout,
      middleware: ['auth'],
      title: 'داشبورد',
    },
  },
]

export default dashboardRoutes
